// this file added by Bearer Web Developer
import React, { useEffect, useRef } from 'react';
import styles from './timer.module.scss';
import formatSecondsToMMSS from '../formatSecondsToMMSS';
import { observer } from 'mobx-react-lite';
import { useAppState } from '../../../../states/app-state';
interface Props {
   
    onFinish?: () => void;
    withMinute?: boolean;
    remainingTime: React.RefObject<number>;
}

const Timer: React.FC<Props> = observer(({  onFinish, remainingTime, withMinute = false, }) => {
    const appState = useAppState();
    const order = appState.selectedOrder!;
    const time = order.cancellationCost.timer;
    const seconds = Number(time) * 60 ;
    const timer = useRef<HTMLSpanElement | null>(null);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const endTimeRef = useRef<number>(Date.now() + seconds * 1000);

    useEffect(() => {
        endTimeRef.current = Date.now() + seconds * 1000;
        if (timer?.current) {
            intervalRef.current = setInterval(() => {
                remainingTime.current = Math.max(0, Math.round((endTimeRef.current - Date.now()) / 1000));
                if (timer.current) timer.current.textContent =
                    withMinute ? formatSecondsToMMSS(remainingTime.current) : remainingTime.current.toString();
                if (remainingTime.current === 0 && intervalRef.current) {
                    clearInterval(intervalRef.current);
                    console.log("Timer finished");
                    onFinish?.();
                }
            }, 1000);
        }
        return () => {
            // Cleanup code to run when the component unmounts
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [seconds])

    return (
        <div className={styles.timer}>
            <img src={"/timer-blue.svg"} alt="" width={20} height={20} />
            <span ref={timer}>{formatSecondsToMMSS(seconds)}</span>
        </div>
    )
})
export default Timer;